<template>
    <div>
      <Loading :value="loading"></Loading>
      <v-layout row>
        <v-flex xs12>
          <v-card color="" class="mb-5" flat>
            <v-layout wrap>
              <v-flex md12>
               
                <v-alert :value="true" outline color="purple" icon="info">
                 ANALYSE DES COÛTS DE RENDEMENT
                </v-alert>
                <br>
                <br>
                <v-layout row class="elevation-12 pt-1 mb-3">
                  <v-flex xs12 class="text-xs-center">
                        <h3>Critères de recherche </h3>
                        <v-divider class="mb-2"></v-divider>
                          <el-form :inline="true" :model="formTri" id="formTri" class="demo-form-inline">

                              <el-form-item label="Projet" width="400 px">
                                  <el-select v-on:change="onchangeInfo(selectProjet)" filterable clearable v-model="selectProjet" placeholder="Projet">
                                      <el-option
                                              v-for="item in listeProjet"
                                              :key="item.id"
                                              :label="item.libelle"
                                              :value="item.id">
                                      </el-option>
                                  </el-select>
                              </el-form-item> 

                              <el-form-item label="Chantier" >
                                  <el-select clearable v-on:change="loadTravaux();onchangeChantier(selectChantier)" v-model="selectChantier" placeholder="Chantier">
                                      <el-option
                                              v-for="item in listeChantier"
                                              :key="item.value"
                                              :label="item.libelle"
                                              :value="item.id">
                                      </el-option>
                                  </el-select>
                              </el-form-item>
                              <el-form-item label="Section" >
                                  <el-select clearable v-model="selectTravaux"  v-on:change="loadTaches();onChangeTravaux(selectTravaux)"   placeholder="Travaux">
                                      <el-option
                                              v-for="item in listeTravaux"
                                              :key="item.value"
                                              :label="item.libelle"
                                              :value="item.id">
                                      </el-option>
                                  </el-select>
                              </el-form-item>


                              <el-form-item label="Tâche" >
                                  <el-select clearable v-model="selectTaches" placeholder="Tâche">
                                      <el-option
                                              v-for="item in listTaches"
                                              :key="item.value"
                                              :label="item.libelle"
                                              :value="item.id">
                                      </el-option>
                                  </el-select>
                              </el-form-item> 

                              <el-form-item label="Période">
                                  <el-date-picker
                                  style="width: 100%"
                                  v-model="selectAnneeMonth"
                                  format="dd-MM-yyyy"
                                  value-format="yyyy-MM-dd"
                                  type="datetimerange"
                                  range-separator="à"
                                  start-placeholder="Début date"
                                  end-placeholder="Fin date"
                                  ></el-date-picker>
                              </el-form-item>
                              
                              <el-form-item label="Année" >
                                    <el-date-picker
                                      type="year"
                                      placeholder="Choisir une  année"
                                      v-model="selectAnnee"
                                      style="width: 100%;"
                                    ></el-date-picker>
                                </el-form-item>

                              <el-form-item label="">
                                  <v-tooltip bottom>
                                      <v-btn @click="loadChantierSearch()" slot="activator" class="white--text" color="blue" fab small>
                                          <v-icon>search</v-icon>
                                      </v-btn>Effectuer une recherche
                                  </v-tooltip>
                              </el-form-item>
                          </el-form>
                    </v-flex>
                </v-layout>
              
               <!-- <v-layout row class="mb-3"  style=" text-align: center;">     -->
              <v-layout row class="elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4">               
                  <v-flex sm12 >
                    <div v-if="showGraph">
                      <v-chip style="border-radius: 16px;" text-color="white" label color="red">VALEUR PLANIFIEE (VP)</v-chip>
                      <v-chip  style="border-radius: 16px;" text-color="white" label color="#2f4554"> VALEUR ACQUISE (VA)</v-chip>
                      <v-chip  style="border-radius: 16px;" text-color="white" label color="#618fa8"> COUT REEL (CR)</v-chip>                      
                      <v-chip  style="border-radius: 16px;" text-color="white" v-if="libelleTravaux !='' && selectAnneeMonth != '' && selectAnneeMonth != null"  label color="primary"> PERIODE: {{selectAnneeMonth ? selectAnneeMonth[0] : ''}} AU {{selectAnneeMonth ? selectAnneeMonth[1] : ''}}  </v-chip>                                  
                    </div>
                     <div id="main" style="width:100%; height: 300px">
                      </div>                      
                  </v-flex>
              </v-layout>  
              
                <br/>
                <v-chip style="border-radius: 16px;" text-color="white" v-if="libelleTravaux !=''" label color="primary"> TABLEAU D'ANALYSE DE LA VALEUR ACQUISE (VP) </v-chip>
                <v-chip  style="border-radius: 16px;" text-color="white" v-if="libelleTravaux !='' && selectAnneeMonth !='' && selectAnneeMonth !='null' && selectAnneeMonth != null"  label color="primary"> PERIODE: {{selectAnneeMonth ? selectAnneeMonth[0] : ''}} AU {{selectAnneeMonth ? selectAnneeMonth[1] : ''}}  </v-chip>                                  
                <v-card color="" class="mb-5">
                  <v-card-text>
                    <v-layout wrap>
                    <v-chip style="border-radius: 16px;" text-color="white" v-if="libelleTravaux !=''" label color="warning">Coût budgété du travail prévu </v-chip>
                      <v-flex xs12 class="text-xs-right" v-if="listTravauxResult.length >0">
                        <v-tooltip top>
                            <v-btn
                                slot="activator"
                                color="orange"
                                @click.stop="dialogueImprimer=true"
                                dark
                            >
                              Exporter en Pdf
                                <v-icon right>print</v-icon>
                            </v-btn>Pdf
                            </v-tooltip>
                            
                            <el-popover v-if="true"
                              placement="top-start"
                              title="DETAILS SUR LES CALCULS DU MONTANT TOTAL ENGAGÉS"
                              width="500"
                              trigger="hover"
                              >
                              <el-table :data="helpDemandeN">                              
                                  <el-table-column width="600" property="text" label=""></el-table-column>
                              </el-table>
                              <el-button v-if="true" style="font-size:25px" icon="el-icon-question" slot="reference"  type="text" ></el-button>
                          </el-popover>
                        </v-flex>
                      <data-tables
                        :data="listTravauxResult"
                        style="width:100%;"
                      >
                      <el-table-column
                          prop="codeTravaux"
                          label="CODE TAVAUX"
                          align="center"
                          width="100"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="orange"
                              color="primary"
                              >{{ scope.row.codeTravaux }}</v-chip
                            >                           
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="libelle"
                          label="LISTE DES TACHES"
                          align="center"
                          width="350"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                              >{{ scope.row.libelle }}</v-chip
                            >
                            <v-chip
                              v-if="scope.row.soutraite == 1"
                              text-color="white"
                              color="orange"
                              >TACHE SOUS-TRAITE</v-chip
                            >
                          </template>
                        </el-table-column>

                        <el-table-column
                          prop="budget"
                          label="BUDGET TOTAL XOF"
                          align="center"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                              >
                              {{ new Intl.NumberFormat().format(scope.row.budgetV) }} 
                              </v-chip
                            >
                          </template>
                        </el-table-column>

                        <!-- <el-table-column label="PERIODE" align="center" v-if="selectAnneeMonth == null">
                          
                          <el-table-column
                            prop="budgetV[1]"
                            label="Jan"
                          ></el-table-column>
                           
                          <el-table-column
                            prop="budgetV[2]"
                            label="Fev"
                          ></el-table-column>
                           
                          <el-table-column
                            prop="budgetV[3]"
                            label="Mar"
                          ></el-table-column>
                           
                          <el-table-column
                            prop="budgetV[4]"                            
                            label="Avr"
                          ></el-table-column>
                          
                          <el-table-column
                            prop="budgetV[5]"                            
                            label="Mai"
                          ></el-table-column>

                          <el-table-column
                            prop="budgetV[6]"                            
                            label="Juin"
                          ></el-table-column>

                          <el-table-column
                            prop="budgetV[7]"
                            label="Juil"
                          ></el-table-column>

                          <el-table-column
                            prop="budgetV[8]"                          
                            label="Aou"
                          ></el-table-column>

                          <el-table-column
                            prop="budgetV[9]"
                            label="Sept"
                          ></el-table-column>

                          <el-table-column
                            prop="budgetV[10]"
                            label="Oct"
                          ></el-table-column>
                          
                          <el-table-column
                            prop="budgetV[11]"
                            label="Nov"
                          ></el-table-column>

                          <el-table-column
                            prop="budgetV[12]"
                            label="Dec"
                          ></el-table-column>
                        </el-table-column> -->

                        <!-- <el-table-column align="center"  label="PERIODE" v-if="selectAnneeMonth != null && selectAnneeMonth != 'null'">
                          <el-table-column align="center" v-if="selectAnneeMonth != null && selectAnneeMonth != 'null'"
                            prop="budgetV[0]"
                            label="PERIODE SÉLECTIONNÉE"
                          ></el-table-column>                           
                        </el-table-column> -->
                      </data-tables>
                      <br />
                    </v-layout>
                    <br>
                  </v-card-text>
                </v-card>

              <br/>       
              <br/>  
              <v-chip style="border-radius: 16px;" text-color="white" v-if="libelleTravaux !=''" label color="warning"> RESULATS DE LA RECHERCHE DU RENDEMENT DES TACHES</v-chip>
                <v-chip  style="border-radius: 16px;" text-color="white" v-if="libelleTravaux !=''"  label color="success"> TRAVAUX: {{libelleTravaux}}</v-chip>
              <v-chip  style="border-radius: 16px;" text-color="white" v-if="libelleTravaux !='' && selectAnneeMonth !='' && selectAnneeMonth !=null && selectAnneeMonth !='null'"  label color="primary"> PERIODE: {{selectAnneeMonth ? selectAnneeMonth[0] :''}} AU {{selectAnneeMonth ? selectAnneeMonth[1] :''}}  </v-chip>                                  
              <v-chip  style="border-radius: 16px;" text-color="white" v-if="libelleTravaux !='' && selectAnnee !='' && selectAnnee != null"  label color="primary"> ANNÉE: {{selectAnnee}} </v-chip>                                                
                <v-card color="" class="mb-5">
                  <v-card-text>

                    <v-layout wrap>
                      <v-flex xs12 class="text-xs-right" v-if="listTravauxResult.length >0">
                        <v-tooltip top>
                            <v-btn
                                slot="activator"
                                color="orange"
                                @click.stop="dialogueImprimer=true"
                                dark
                            >
                              Exporter en Pdf
                                <v-icon right>print</v-icon>
                            </v-btn>Pdf
                            </v-tooltip>
                            
                            <el-popover v-if="true"
                              placement="top-start"
                              title="DETAILS SUR LES CALCULS DU MONTANT TOTAL ENGAGÉS"
                              width="500"
                              trigger="hover"
                              >
                              <el-table :data="helpDemandeN">
                                  <!-- <el-table-column width="20" property="num" label=""></el-table-column> -->
                                  <el-table-column width="600" property="text" label=""></el-table-column>
                              </el-table>
                              <el-button v-if="true" style="font-size:25px" icon="el-icon-question" slot="reference"  type="text" ></el-button>
                          </el-popover>
                        </v-flex>

                      <data-tables
                        :data="listTravauxResult"
                        style="width:100%;"
                      >
        
                        <el-table-column
                          prop="libelle"
                          label="LISTE DES TACHES"
                          align="center"
                          width="350"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                              >{{ scope.row.libelle }}</v-chip
                            >
                            <v-chip
                              v-if="scope.row.soutraite == 1"
                              text-color="white"
                              color="orange"
                              >TACHE SOUS-TRAITE</v-chip
                            >
                          </template>
                        </el-table-column>

                        <el-table-column label="PREVISIONNEL" align="center" 
                            fixed 
                          width="210">
                          
                          <el-table-column
                            prop="rmtGlobal"
                            label="RDMT TOTAL"
                            width="100"
                          ></el-table-column>
                          
                          <el-table-column
                            prop="prixBudget"
                                    label="PRIX BUDGET"                            
                                  width="110"
                                  >
                                  </el-table-column>
                        </el-table-column>
                        

                       
                        <el-table-column label="REEL" align="center">

                          <el-table-column label="Rendements Reel" align="center" v-if="selectAnneeMonth == null">

                          <el-table-column
                            prop="rdmt[1]"
                            label="Jan"
                          ></el-table-column>
                          
                          <el-table-column
                            prop="rdmt[2]"
                            label="Fev"
                          ></el-table-column>
                          
                          <el-table-column
                            prop="rdmt[3]"
                            label="Mar"
                          ></el-table-column>
                          
                          <el-table-column
                            prop="rdmt[4]"                            
                            label="Avr"
                          ></el-table-column>

                          <el-table-column
                            prop="rdmt[5]"                            
                            label="Mai"
                          ></el-table-column>

                          <el-table-column
                            prop="rdmt[6]"                            
                            label="Juin"
                          ></el-table-column>

                          <el-table-column
                            prop="rdmt[7]"
                            label="Juil"
                          ></el-table-column>

                          <el-table-column
                            prop="rdmt[8]"                          
                            label="Aou"
                          ></el-table-column>

                          <el-table-column
                            prop="rdmt[9]"
                            label="Sept"
                          ></el-table-column>

                          <el-table-column
                            prop="rdmt[10]"
                            label="Oct"
                          ></el-table-column>

                          <el-table-column
                            prop="rdmt[11]"
                            label="Nov"
                          ></el-table-column>

                          <el-table-column
                            prop="rdmt[12]"
                            label="Dec"
                          ></el-table-column>
                          </el-table-column>

                          <el-table-column label="Rendements Reel" align="center"  v-if="selectAnneeMonth != null && selectAnneeMonth != 'null'">
                              <el-table-column  align="center"  v-if="selectAnneeMonth != null && selectAnneeMonth != 'null'"
                                prop="rdmt[0]"
                                label="PERIODE SÉLECTIONNÉE"
                              ></el-table-column>
                            </el-table-column>

                          <el-table-column
                            prop="prixRevient"
                            label="PRIX REVIENT XOF"
                            width="100"
                          >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="warning"
                              >{{ new Intl.NumberFormat().format(scope.row.prixRevient) }} </v-chip
                            >
                          </template>
                          </el-table-column>

                          </el-table-column>
                        
                       <el-table-column label="ECART" align="center">

                          <el-table-column label="RDMT" align="center" v-if="selectAnneeMonth == null">
                          
                          <el-table-column
                            prop="ecarRdmt[1]"
                            label="Jan"
                          ></el-table-column>
                           
                          <el-table-column
                            prop="ecarRdmt[2]"
                            label="Fev"
                          ></el-table-column>
                           
                          <el-table-column
                            prop="ecarRdmt[3]"
                            label="Mar"
                          ></el-table-column>
                           
                          <el-table-column
                            prop="ecarRdmt[4]"
                            label="Avr"
                          ></el-table-column>
                          
                          <el-table-column
                            prop="ecarRdmt[5]"
                            label="Mai"
                          ></el-table-column>
                          <el-table-column
                            prop="ecarRdmt[6]"
                            label="Juin"
                          ></el-table-column>
                          <el-table-column
                            prop="ecarRdmt[7]"
                            label="Juil"
                          ></el-table-column>
                          <el-table-column
                            prop="ecarRdmt[8]"
                            label="Aou"
                          ></el-table-column>
                          <el-table-column
                            prop="ecarRdmt[9]"
                            label="Sept"
                          ></el-table-column>
                          <el-table-column
                            prop="ecarRdmt[10]"
                            label="Oct"
                          ></el-table-column>
                          
                          <el-table-column
                            prop="ecarRdmt[11]"
                            label="Nov"
                          ></el-table-column>
                          <el-table-column
                            prop="ecarRdmt[12]"
                            label="Dec"
                          ></el-table-column>
                          </el-table-column>

                          <el-table-column label="RDMT" align="center"  v-if="selectAnneeMonth != null && selectAnneeMonth != 'null'">                          
                            <el-table-column  align="center"  v-if="selectAnneeMonth != null && selectAnneeMonth != 'null'"
                              prop="ecarRdmt[0]"
                              label="PERIODE SÉLECTIONNÉE"
                            ></el-table-column>
                          </el-table-column>

                          <el-table-column
                            prop="prixEcartRevient"
                            label="PRIX REVIENT XOF"
                            width="100"
                          >

                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="red"
                              >
                              {{ new Intl.NumberFormat().format(scope.row.prixEcartRevient) }} 
                            </v-chip>
                          </template>
                          </el-table-column>

                        </el-table-column>
                      </data-tables>
                      <br />
                    </v-layout>
                    <br>
                  </v-card-text>
                </v-card>
                
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>


    <!-- MODAL IMPRESSION BDE COMMANDE-->
      <v-dialog v-model="dialogueImprimer" max-width="50%" :overlay="true" scrollable persistent>
        <v-card>
          <v-card-text text-xs-center>
              <p align="center">
                <v-btn @click.stop="imprimerModePlan(2)" color="green" dark>
                  Paysage
                  <v-icon right>print</v-icon>
                </v-btn>
                <v-btn icons color="orange" @click.stop="imprimerModePlan(1)" dark>
                  Portrait
                  <v-icon right>print</v-icon>
                </v-btn>
              </p>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
        <v-btn icon @click.native="dialogueImprimer = false" dark class="blue"
          ><v-icon>close</v-icon>
        </v-btn>
    </v-dialog>

    </div>
  </template>
  
  <style>
      .card {
          background-color: #fff;
          border-color: black;
          border-radius: 10px;
          border: none;
          position: relative;
          margin: 0 auto;
          text-align: center;
          margin-bottom: 30px;
          box-shadow: 0 0.46875rem 2.1875rem rgba(90,97,105,0.1), 0 0.9375rem 1.40625rem rgba(90,97,105,0.1), 0 0.25rem 0.53125rem rgba(90,97,105,0.12), 0 0.125rem 0.1875rem rgba(90,97,105,0.1);
      }
     #appercu{
       position: absolute;
        top: 15px;
        left: 40px;
        display: none;
        width: 40px;
        height: 20px;
     }
     .card h4:hover{
       display: block;
      }
  
      #price{
        border: none;
        position: relative;
        margin: 0 auto;
        text-align: center;
      }
  
      .l-bg-cherry {
          background: linear-gradient(to right, #493240, #f09) !important;
          color: #fff;
      }
  
      .l-bg-blue-dark {
          background: linear-gradient(to right, #373b44, #4286f4) !important;
          color: #fff;
      }
  
      .l-bg-green-dark {
          background: linear-gradient(to right, #0a504a, #38ef7d) !important;
          color: #fff;
      }
  
      .l-bg-red-dark {
          background: linear-gradient(to right, #c71111, #ffba56) !important;
          color: #fff;
      }
      .l-bg-orange-dark {
          background: linear-gradient(to right, #a86008, #ffba56) !important;
          color: #fff;
      }
  
      .card .card-statistic-3 .card-icon-large .fas, .card .card-statistic-3 .card-icon-large .far, .card .card-statistic-3 .card-icon-large .fab, .card .card-statistic-3 .card-icon-large .fal {
          font-size: 110px;
      }
  
      .card .card-statistic-3 .card-icon {
          text-align: center;
          line-height: 50px;
          margin-left: 15px;
          color: #000;
          position: absolute;
          right: -5px;
          top: 20px;
          opacity: 0.1;
      }
  
      .l-bg-cyan {
          background: linear-gradient(135deg, #289cf5, #84c0ec) !important;
          color: #fff;
      }
  
      .l-bg-green {
          background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%) !important;
          color: #fff;
      }
  
      .l-bg-orange {
          background: linear-gradient(to right, #f9900e, #ffba56) !important;
          color: #fff;
      }
  
      .l-bg-red {
          background: linear-gradient(to right, #c71111, #ffba56) !important;
          color: #fff;
      }
  
      .l-bg-cyan {
          background: linear-gradient(135deg, #289cf5, #84c0ec) !important;
          color: #fff;
      }
  </style>
  
  <script>
    var echarts = require('echarts/lib/echarts')
    require('echarts/lib/chart/bar')
    require('echarts/lib/chart/pictorialBar')
    require('echarts/lib/chart/funnel')
    require('echarts/lib/chart/sankey')
    require('echarts/lib/chart/scatter')
    require('echarts/lib/chart/pie')
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')

    import ECharts from 'vue-echarts'
    import 'echarts/lib/chart/line'
    // import * as echarts from 'echarts';

    import Loading from "@/components/Loading";
    export default {
    components: { Loading ,
      'v-chart': ECharts
    },
    name: "DashboardRapport",
    props: {
      show: {
        type: Boolean
      },
      detailProjet: {
        type: Object
      }
    },
    data() {
      return {
        //data general
        domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
        user: JSON.parse(sessionStorage.getItem("userInfo")),
        roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
        droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
  
        loading: false,
        dialogDetail: false,
        showButonExcel: false,
        dialogueImprimer: false,
        listeProjet: [],
        listeRecherche: [],
        listeRapport : [],
        listeChantier: [],
        listeTravaux: [],
        listTaches: [],
        listTravauxResult: [],
        listChargeResult: [],
        mntTotalChargeI:0,
        showGraph:false,
        mntTotalChargeD:0,
        mntTotalChargeDE: 0,
        mntTotalChargeMA: 0,
        mntTotalDepense: 0,
        listeBudget: [],
        bilanMensuel: [],
        bilanTravaux: [],
        listeDetail: [],
        helpDemande:[{
              num: "1",
              text:"Somme de toutes les commandes éffectuées"
          },
          {
              num: "2",
              text:"Somme de toutes les demandes de fond éffectuées"
          },
          {
              num: "3",
              text:"Somme de toutes les dépenses indiquée dans le rapport journalier"
          },
          ],
          helpDemandeN:[
          {
              num: "1",
              text:"REDEMENT GLOBAL: Qte tâche / Durée totale prévue."
          },          {
              num: "1",
              text:"REDEMENT RÉEL: Le rendement réel d'une tâche d'un projet par jour: Calculé en divisant le nombre de tâches effectuées par le nombre de jours consacrés à la tâche."
          },          
          {
              num: "2",
              text:"Prix BUDGET: Somme de toutes les commandes effectuées pour la tâche."
          },
          {
              num: "3",
              text:"ECART PRIX DE REVIENT: L'écart du prix de revient d'une tâche peut être calculé en soustrayant le coût réel de la tâche à son coût prévu. Par exemple, si le coût prévu pour une tâche était de 100 et que le coût réel était de 120, l'écart du prix de revient serait de 2"
          },
          {
              num: "4",
              text:"ECART REDEMENT: L'écart de rendement d'une tâche d'un projet peut être calculé en soustrayant le rendement réel de la tâche à son rendement attendu. Par exemple, si la tâche a été estimée à prendre 100 heures pour être terminée, mais qu'elle a pris 120 heures, alors l'écart de rendement sera de -20 heures."
          },
          {
              num: "5",
              text:"COUT RÉEL:Le coût réel d'une tâche d'un projet est le coût final de la réalisation de cette tâche, c'est-à-dire le coût réellement dépensé pour la réaliser."
          }
          ,
          {
              num: "6",
              text:"VALEUR PLANIFIÉE: La valeur planifiée d'une tâche d'un projet est le coût estimé de la réalisation de cette tâche."
          }
          
          ],


        //  new data
        selectProjet: [],
        selectChantier: [],
        selectTravaux: [],
        selectAnnee:'',
        selectTaches:'',
        libelleTravaux: '',
        selectAnneeFormat:'',
        selectAnneeMonth:null,
        //critere de recherche
        formTri:{periode:'',},

        compte: "0",
        dialogConfirm: false,
        disabledBtnPop: false,
        totalMntPropose: 0,
        totalMntValide: 0,
      };
    },
  
    computed: {},
    watch: {
      show: function(newValue, oldvalue) {
        this.dialogDetail = newValue;
        if (newValue == true) {
          this.listeBudget = this.detailProjet.budgets;
          let _this = this;
          this.totalMntPropose = 0;
          this.totalMntValide = 0;
          this.totalMntMarche = 0;
          this.listeBudget.forEach(item => {
            this.totalMntPropose += item.mntTotalBudgetPropose;
            this.totalMntValide += item.mntTotalBudgetValide;
          });
          this.loadBilan(this.detailProjet.idProj);
        }
      }
    },
  
    methods: {
      handleTabClick(tab) {
        switch (tab) {
          case "0":
            break;
          case "1":
            break;
  
          default:
            break;
        }
      },
      headerRowStyle({ row, rowIndex }) {
      return { color: "black" };
    },
      statistique(dataStat) {
        var chartDom = document.getElementById('main');        
          var myChart = echarts.init(chartDom);
          var option;

          option = {
            title: {
                text: 'Rapport d\'analyse de la valeur acquise',
              },
              tooltip: {
                  trigger: 'axis',
              },
              legend: {              
                  data: ['VALEUR PLANIFIEE (VP)', 'VALEUR ACQUISE (VA)', 'COUT REEL (CR),']
              },                   
              grid: {
                left: '10%',
                right: '10%',
                bottom: '10%',
                containLabel: true
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: [] // Les données seront assignées en fonction de la condition
              },            
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: 'VALEUR PLANIFIEE',
                type: 'line',
                stack: 'Total',
                data: []
              },
              {
                name: 'VALEUR ACQUISE',
                type: 'line',
                stack: 'Total',
                data: []
              },
              {
                name: 'COUT REEL',
                type: 'line',
                stack: 'Total',
                data: []
              }
            ]
          };
          
          if (this.selectAnneeMonth !== '' && this.selectAnneeMonth !== null) {
            option.xAxis.data = ["PERIODE: " + this.selectAnneeMonth[0] + " AU " + this.selectAnneeMonth[1]];
          } else { 
            option.xAxis.data = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'];
          }
          let tabNb = option.xAxis.data.length
          if (this.selectAnneeMonth !== '' && this.selectAnneeMonth !== null && this.selectAnneeMonth !== 'null') {
            option.series[0].data.push({value:dataStat[0]['vp'],name: "VALEUR PLANIFIEE (VP)"});
            option.series[1].data.push({value:dataStat[0]['va'],name: "VALEUR ACQUISE (VA)"});
            option.series[2].data.push({value:dataStat[0]['cr'],name: "COUT REEL (CR)"});              
          }else {
           
            for (let i=0; i<tabNb; i++) {
              for(let dataCBud in dataStat){
               let mois =  option.xAxis.data           
                if(mois[i] === dataStat[dataCBud]['mois']) {                
                  option.series[0].data.push({value:dataStat[dataCBud]['vp'],name: "VALEUR PLANIFIEE (VP)"});
                  option.series[1].data.push({value:dataStat[dataCBud]['va'],name: "VALEUR ACQUISE (VA)"});
                  option.series[2].data.push({value:dataStat[dataCBud]['cr'],name: "COUT REEL (CR)"});
                }                      
            }
          }
          }      
          option && myChart.setOption(option);
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "Sous total";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = new Intl.NumberFormat().format(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
            );
          } else {
            sums[index] = "N/A";
          }
        });
  
        return sums;
      },
      getSumm(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "Sous total";
            return;
          }
  
          if (index === 4) {
            sums[index] = "N/A";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = new Intl.NumberFormat().format(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
            );
          } else {
            sums[index] = "N/A";
          }
        });
  
        return sums;
      },
      closeDialog() {
        this.$emit("close");
      },
      getSummCompte(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "Sous total";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = new Intl.NumberFormat().format(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
            );
          } else {
            sums[index] = "N/A";
          }
        });
        return sums;
      },
      getSummCompteFinance(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "Sous total";
            return;
          }
  
          if (index === 6) {
            sums[index] = "N/A";
            return;
          }
  
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = new Intl.NumberFormat().format(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
            );
          } else {
            sums[index] = "N/A";
          }
        });
  
        return sums;
      },
      getSummDetailBudget(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "Sous total";
            return;
          }
  
          if (index === 5) {
            sums[index] = "N/A";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
      

          if (!values.every(value => isNaN(value))) {
            
            sums[index] = 

            new Intl.NumberFormat().format(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
            );
          } else {
            sums[index] = "N/A";
          }
        });
  
        return sums;
      },
      loadBilan(idProjet) {
        this.loading = true;
        let url = this.domaine + "budgetProjet/bilan/projet/" + idProjet;
        this.$http.get(url).then(
          response => {
            this.loading = false;
            this.bilanMensuel = response.body.mensuel;
            this.bilanTravaux = response.body.bilanTravaux.travaux;
            this.listeDetail = response.body.detailCompte;
          },
          errRep => {
            this.loading = false;
            this.$message.error(
              "Une erreur est survenue lors du chargement du bilan"
            );
          }
        );
      },
      loadProjet() {
          let url = this.domaine + "projet/indicateur/projet";

          this.loading = true;
          this.$http.get(url).then(
              response => {
                  this.loading = false;
                  this.listeProjet = response.body.projet;
                  // this.listeRapport = response.body.rapport;
              },
              errRep => {
                  this.loading = false;
                  this.$message.error(
                      "Une erreur est survenue lors du chargement de la liste des projets"
                  );
              }
          );
      },
      loadChantierSearch() {
        this.loading = true;
      this.listTravauxResult = [];
      this.listChantierResult = [];
    
      if (this.selectAnneeMonth && this.selectAnnee) { 
        this.loading = false;
        this.$message.error(
            "Veuillez sélectionner une période ou une année."
        );
      }else {

          if (this.selectTravaux != "" && this.selectChantier != "") {
            this.loading = true;

            this.listeTravaux.find((item)=>{
                  if(item.id == this.selectTravaux) {
                    this.libelleTravaux = item.libelle
                  }
              })                   
                 let dateSelect = null    
                  if(this.selectAnnee ) {
                    let tabDFin = new Intl.DateTimeFormat('en-GB').format(this.selectAnnee).split("/")
                    dateSelect = tabDFin[2]
                    this.selectAnneeFormat = tabDFin[2] 
                  }                   
                this.selectAnnee = dateSelect              
            let url =
              this.domaine +
              "projet/chantier/"+this.selectChantier+"/travaux/"+this.selectTravaux+"/annee/"+dateSelect+"/periode/"+(this.selectAnneeMonth ? this.selectAnneeMonth : null)+"/taches/"+(this.selectTaches ? this.selectTaches : null)+"/rendement";
            this.$http.get(url).then(response => {
              if (response.body) {
                this.loading = false;      
                this.showGraph = true;
                this.listTravauxResult = response.body.taches;
                this.statistique(response.body.statRendet)
              }
            });
          } else {
            this.$message.error("Veuillez sélectionner le chantier et un travaux");
            this.loading = false;
          }
       }
      },

    loadTravaux() {
      this.loading = true;
      this.travauxS = "";
      this.listTravaux = [];
      if (this.selectChantier != "" && this.selectChantier != null) {
        let url =
          this.domaine + "projet/" + this.selectChantier + "/index/chantier/travaux";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listeTravaux = response.body.travaux;
            this.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    onchangeInfo(projetS){
        this.listeProjet.find((item)=>{
              if(item.id == projetS) {
                this.listeChantier = item.chantier
              }
          })
      },
      onchangeChantier(chantierS) {
        this.listeChantier.find((item)=>{
              if(item.id == chantierS) {
                this.listeTravaux = item.travauxId
              }
          })
      },

      loadTaches() {
        // this.loading = true;
          let url =
            this.domaine + "projet/travaux_tache/"+ this.selectTravaux+"/index/tache";
          this.$http.get(url).then(response => {
            if (response.body) {
              this.listTaches = response.body.tache;
              this.loading = false;
            }
          });
      },
      onChangeTravaux(travaux) {
        if(travaux && travaux != 'null') {
          this.listeTravaux.find((item)=>{
              if(item.idChantier == travaux) {
                this.listTaches = item.travauxId
              }
          })
        }

      },
      imprimerModePlan(mode){             
        let url = this.domaine + "projet/chantier/"+this.selectChantier+"/travaux/"+this.selectTravaux+"/annee/"+ this.selectAnnee +"/tache/"+(this.selectTaches ? this.selectTaches : null)+"/imprimer/rendement/"+this.user.id+"/"+mode+'/periode/'+(this.selectAnneeMonth ? this.selectAnneeMonth : null)
        this.$http.get(url).then(response => {
            if (response.body) {
            }
        })
      this.dialogueImprimer = false
      window.open(url)
  },
    },
    mounted() {
      this.loadProjet()
    }
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/projet/DashboardRapport.vue